import styles from './ConfiguratorColour.module.scss';
import { Image } from '@sitecore-jss/sitecore-jss-react';
import Button from '../../../ui/Button/Button';
import cn from 'classnames';
import React from 'react';
import Chevron from '../../../Icons/Chevron';
import { formatCurrency } from '../utils';

export default function Colour({
  step,
  index,
  selectedCategoryCar,
  onClickColourItem,
  onClickStep,
  sitecoreData,
}) {
  const stepItems = step.carTypes[selectedCategoryCar].items;
  const stepSelectedItem = stepItems?.find((item) => item.selected);

  return (
    <div className={styles.wrapper}>
      <div className={styles.card}>
        <h3 className={styles.card_title}>{step?.title}</h3>
        <p className={styles.card_text}>{step?.text}</p>
        <ul className={styles.card_list}>
          {stepItems.map((item) => {
            return (
              <React.Fragment key={item.id}>
                <li
                  className={cn(
                    styles.card_list_item,
                    item.selected && styles.card_list_item_active
                  )}
                  key={item.id}
                  onClick={() => onClickColourItem(item.id)}
                >
                  <Image field={item.color} />
                </li>
                {item.selected && (
                  <div className={styles.card_list_item_color}>
                    {item?.colorName}:{' '}
                    <span>
                      {formatCurrency(item.price, step?.priceUnit)
                        ? formatCurrency(item.price, step?.priceUnit)
                        : step?.noPriceText}
                      {item?.inclVAT && <span> {item.inclVAT}</span>}
                    </span>
                  </div>
                )}
              </React.Fragment>
            );
          })}
        </ul>
        <div className={styles.card_buttonsBlock}>
          <button
            className={styles.card_buttonsBlock_buttonBack}
            onClick={() => onClickStep(index - 1)}
          >
            <Chevron color="rgba(18, 18, 18, 1)" isRotated />
          </button>
          <div className={styles.card_buttonsBlock_buttonWrapper}>
            <Button
              className={styles.card_buttonsBlock_buttonWrapper_button}
              onClick={() => onClickStep(index + 1)}
              isShowTooltip={false}
            >
              {step?.buttonText || 'Continue'}
              <Chevron />
            </Button>
          </div>
        </div>
      </div>
      <div className={styles.image}>
        <Image field={stepSelectedItem?.image} />
      </div>
    </div>
  );
}
